import {FormProvider, useForm} from 'react-hook-form';
import FormActions from 'components/Form/FormActions';
import FormHeader from 'components/Form/FormHeader';
import FormResult from 'components/Form/FormResult';
import InputSanitized from 'components/Form/InputSanitized';
import {usernameSanitizer} from 'components/Form/InputSanitized/utils';
import SubmitButton from 'components/Form/SubmitButton';
import SideBySide from 'components/Layout/SideBySide';
import {useBackend} from 'state/backend';
import {gettext} from 'ttag';
import {Backend} from 'types/api';
import {FormFields} from 'types/utils';
import {setUrl} from 'utils/request';
import {onApiFormError} from 'utils/request/result';
import {ProfileRequest, usePatchProfile} from './services';

export type ProfileChangeUsernameBackend = Backend<{
    username: string;
}>;

type ProfileChangeUsernameFormData = FormFields<ProfileRequest>;

const ChangeUsername = () => {
    const {data} = useBackend<ProfileChangeUsernameBackend>();

    const methods = useForm<ProfileChangeUsernameFormData>({
        defaultValues: {
            username: data?.username,
        },
    });
    const {
        formState: {isDirty},
        handleSubmit,
    } = methods;

    const {mutateAsync} = usePatchProfile();

    const onSubmit = async (formData: ProfileChangeUsernameFormData) => {
        await mutateAsync(formData)
            .then(() => {
                setUrl(window.Urls.profile_view());
            })
            .catch(onApiFormError(methods));
    };

    return (
        <FormProvider {...methods}>
            <form className="hide-required" onSubmit={handleSubmit(onSubmit)}>
                <SideBySide className="max-w-xl">
                    <FormHeader
                        hideHR={true}
                        title={gettext('Change Username')}
                    />
                    <InputSanitized
                        aria-label={gettext('Username')}
                        helpText={gettext('Letters, digits and ./+/-/_ only.')}
                        label={gettext('Username')}
                        name="username"
                        required={true}
                        sanitizer={usernameSanitizer}
                    />
                    <FormResult />
                    <FormActions align="left">
                        <SubmitButton disabled={!isDirty}>
                            {gettext('Change Username')}
                        </SubmitButton>
                    </FormActions>
                </SideBySide>
            </form>
        </FormProvider>
    );
};

export default ChangeUsername;
